import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as layout from "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import { createActionIcon } from "../../../atomic/actions/icon.js";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-utilities-library/styles";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
import { createTextLockupSmallScaling } from "../../../atomic/text-lockup/small-scaling.js";
const createCompositeCardOverlayColor = (props) => {
  const { isThemeDark, ctaIcon } = props;
  const children = [];
  if (ctaIcon && ctaIcon instanceof HTMLElement) {
    children.push(
      createActionIcon({
        ...props,
        ctaIcon,
        isThemeLight: !isThemeDark
      })
    );
  }
  const lockup = createTextLockupSmallScaling(props);
  const wrapper = new ElementBuilder().withClassName("card-overlay-color-wrapper").withStyles({
    element: {
      paddingRight: `${ctaIcon ? token.spacing["2xl"] : 0}`,
      height: "100%",
      [`& > *`]: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        zIndex: 9,
        position: "relative",
        maxWidth: `${token.spacing.maxWidth.smallest}`
      }
    }
  }).withChild(lockup).build();
  children.push(wrapper);
  return new ElementBuilder().withClassName("card-overlay-color").withStyles({
    element: {
      padding: `${token.spacing.lg} ${token.spacing.md}`,
      minHeight: "360px",
      display: "grid",
      height: "100%",
      overflow: "hidden",
      position: "relative",
      backgroundColor: token.color.gray.lightest,
      ...isThemeDark && {
        backgroundColor: token.color.gray.darker
      },
      [`& .${layout.grid.inline.tabletRows.className}`]: {
        [`@media (${token.media.queries.tablet.min})`]: {
          marginTop: "auto !important"
        }
      },
      [`@container  (min-width: 600px)`]: {
        paddingLeft: token.spacing.xl,
        paddingRight: token.spacing.xl
      }
    }
  }).withChildren(...children).build();
};
export {
  createCompositeCardOverlayColor
};
//# sourceMappingURL=color.js.map
